function HodFyzFaktorovPracProstredia(){
    return(
        <div>
            HodFyzFaktorovPracProstredia
        </div>
    );
};

export default HodFyzFaktorovPracProstredia;